export function normalizeHexColor(value: string) {
  const trimmed = value.trim().toLowerCase()

  if (/^#[0-9a-f]{3}$/.test(trimmed)) {
    return `#${trimmed.slice(1).split("").map((char) => char + char).join("")}`
  }

  if (/^#[0-9a-f]{6}$/.test(trimmed)) {
    return trimmed
  }

  return "#0f766e"
}

export function hexToRgb(value: string) {
  const hex = normalizeHexColor(value).slice(1)
  return {
    r: Number.parseInt(hex.slice(0, 2), 16),
    g: Number.parseInt(hex.slice(2, 4), 16),
    b: Number.parseInt(hex.slice(4, 6), 16),
  }
}

export function contrastingTextColor(value: string) {
  const { r, g, b } = hexToRgb(value)
  const luminance = (r * 299 + g * 587 + b * 114) / 1000
  return luminance >= 150 ? "#0f172a" : "#ffffff"
}
